import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 11v.01","key":"svg-0"}],["path",{"d":"M11 10v.01","key":"svg-1"}],["path",{"d":"M10 14v.01","key":"svg-2"}],["path",{"d":"M11.059 6.07a8 8 0 1 0 .32 15.81","key":"svg-3"}],["path",{"d":"M15.969 9h4","key":"svg-4"}],["path",{"d":"M14.969 5c0 1.5 1 2 1 4c0 2.5 -2 4.5 -2 7c0 2.6 1.9 6 1.9 6h4.1s2 -3.4 2 -6c0 -2.5 -2 -4.5 -2 -7c0 -2 1 -2.5 1 -4a3 3 0 1 0 -6 0","key":"svg-5"}]]

const IconBowling = createReactComponent('outline', 'bowling', 'Bowling', __iconNode);

export default IconBowling;